import React from 'react';
import { Link } from 'react-router-dom';

import MainLayout from '../common/MainLayout';

function ThankYou() {
  return (
    <MainLayout>
      <div className="text-center space-y-8">
        <div className="mb-6">
          <div className="w-20 h-20 bg-gradient-to-br from-hdlcc-success to-hdlcc-success/80 rounded-full flex items-center justify-center mx-auto mb-6 shadow-glow-success">
            <svg
              className="w-10 h-10 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              strokeWidth="3"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h2 className="text-3xl font-bold text-hdlcc-textPrimary tracking-tight">
            Registration Complete!
          </h2>
        </div>

        <div className="bg-hdlcc-mediumGray border border-hdlcc-lightGray/20 p-8 rounded-xl shadow-elevation-1 space-y-4">
          <p className="text-hdlcc-textSecondary text-lg leading-relaxed">
            Your membership application has been submitted successfully.
          </p>
          <p className="text-hdlcc-textSecondary leading-relaxed">
            We&apos;ll review your application and send you a confirmation email with further
            instructions within the next 2-3 working days.
          </p>
        </div>

        <div className="space-y-5">
          <div className="bg-hdlcc-mediumGray border border-hdlcc-lightGray/20 p-6 rounded-xl shadow-elevation-1">
            <p className="text-sm text-hdlcc-textTertiary">
              If you have any questions, please contact us at{' '}
              <a
                href="mailto:membership@hdlcc.com"
                className="text-hdlcc-primary hover:text-hdlcc-primaryLight font-medium transition-colors"
              >
                membership@hdlcc.com
              </a>
            </p>
          </div>
          <Link
            to="/"
            className="inline-flex items-center bg-gradient-to-r from-hdlcc-primary to-hdlcc-primaryLight text-white px-8 py-3 rounded-xl hover:shadow-glow-primary transition-all duration-200 font-semibold shadow-elevation-1"
          >
            Return to Home
          </Link>
        </div>
      </div>
    </MainLayout>
  );
}

export default ThankYou;
